const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import PromoteView from "./promote_view";
import ModuleManager from "../../../../framework/core/module_manager";
import GameUtil from "../../../../utility/game_util";
import AppData from "../../../public/const/app_data";
import ModelData, { IUserData } from "../../../public/model_data";
import BindInviteCode from "../bindinvitecode/bindinvitecode";
import SdkManager from "../../../../manager/sdk_manager";
import SdkDefine from "../../../../sdk/collection/sdk_define";
import AppController from "../../../../sdk/app_controller";
import Utility from "../../../../utility/utility";

@ccclass
@moduleInit("Promote")
export default class Promote extends ModuleBase<PromoteView, null>  {
    countData = null
    awardData = null
    constructor() {
        super()
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = 'package/hall/module/promote/promote_table';
        this.viewType = PromoteView;
        this.needViewMask = true
        this.clickAnywhereClose = false
        this.needViewBaseBg = true
        this.needViewBaseCloseBtn = true
        this.needViewBaseTitleBg = true
        this.needAnim = true
        this.autoShowAnim = false
    }

    onInit(intentData) {
        this.bindEvent()
    }

    onShow(intentData) {
        if (intentData != null && typeof (intentData) == "object") {
            this.getPromoteAD((promotedata) => {
                let url = promotedata.qrcode + `/?inviteCode=${promotedata.inviteCode}`
                if (intentData.getDownloadUrl) {
                    if (!CC_JSB) { 
                        if (promotedata.qrcode.endsWith('/')) {
                            url = promotedata.qrcode + `${AppData.userConnectEnvi == 0 ? "app.html" : ""}?inviteCode=` + promotedata.inviteCode
                        } else {
                            url = promotedata.qrcode + `${AppData.userConnectEnvi == 0 ? "/app.html" : ""}?inviteCode=` + promotedata.inviteCode
                        }
                        AppData.appDownloadUrl = url
                    }
                } 
                if (intentData.callback) {
                    intentData.callback(url)
                }
                this.hide()
                ModuleManager.instance.hideModule("NetPrompt")
                return
            })
        }
        this._viewMask.active = false
        this.view.node.active = false
        this.showNetPrompt(true)
        this.showMain()
    }

    showMain() {
        let self = this
        this.getPromoteAD((promotedata) => {
            self.getUserData(ModelData.instance.roleData.id, (data: IUserData) => {
                self.view.showMainView(data, promotedata)
                self.showNetPrompt(false)
                self.showAnim()
            })


            //下载推广介绍图
            // TextureManager.instance.getSprite(encodeURI(promotedata.indexUrl) , (sprite)=>{  //ios url不能带有中文等特殊字符
            //     self.view.ruleSpr.spriteFrame = sprite
            // })

            self.getEarningsData((data) => {
                self.awardData = data
                self.view.showMyRewardView(data)
                self.getAwardCount()
            })

        })

    }

    protected onButtonClickName(name: string) {
        let self = this
        switch (name) {
            case "CloseBtn":
                this.hide()
                break;
            case "InviteBtn":
                ModuleManager.instance.showModule(BindInviteCode)
                break
            case "copyBtn":
                //复制邀请码
                ModuleManager.instance.toastKey("promote_enterCopy")
                AppController.instance.copyTextToClipboard(this.view.myInviteCode.string)
                break
            case "ShareBtn":
                //保存图片
                GameUtil.captureScreen(this.view.sharePenel, null)
                break
            case "SharelineBtn":
            case "ShareFBBtn":
                let content = null;
                if (cc.sys.isNative) {
                    GameUtil.captureScreen(this.view.sharePenel, (path) => {
                        content = { "image": path };
                    })
                } else if (cc.sys.isBrowser) {

                    let invite = ModelData.instance.roleData.inviteCode;
                    let url = invite ? Utility.getUrl() + "?inviteCode=" + invite : Utility.getUrl();
                    content = { link: url };
                }
                if (content) {
                    let sdk_name = name == "SharelineBtn" ? SdkDefine.LINE_NAME : SdkDefine.FACE_BOOK_NAME;
                    SdkManager.instance.req_share(sdk_name, content);
                }
                break
            case "CopyUrlBtn":
                //复制下载链接
                ModuleManager.instance.toastKey("promote_enterCopy")
                AppController.instance.copyTextToClipboard(this.view.promoteUrl)
                break
            case "WithdrawalBtn":
                this.getAward((count) => {
                    ModuleManager.instance.showModuleName('DialogReceive', { chipNum: count })
                    self.getAwardCount()
                    self.getEarningsData((data) => {
                        self.view.showMyRewardView(data)
                    })
                    self.getSelfCurrencyData(null, true)
                }
                )
                break
            case "FindBtn":
                this.getFindPlayerData()
                break
            case "ResetBtn":
                this.view.showFindPlayerInfo(null)
                break
            case "PromoteLvBtn":
                this.view.lvRuletTips.active = true
                break
            case "TimeLvBtn":
                this.view.timeRuleTips.active = true
                break
            case "lvruletips":
                this.view.lvRuletTips.active = false
                break
            case "timeruletips":
                this.view.timeRuleTips.active = false
                break
            default:
                break;
        }
    }

    //查找下级玩家数据
    getFindPlayerData() {
        let self = this
        this.findPlayer(this.view.findInPut.string, (playerdata) => {
            self.getUserData(playerdata.gameUserId, (data: IUserData) => {
                self.view.showFindPlayerInfo(data)
            })

        })
    }

    //我的收益界面
    getEarningsData(callback) {
        let requestData: IHttpRequestData = {
            baseUrl: "promoters/myReward?",
        }
        this.apiHttpGet(requestData, function (retData) {
            if (callback) {
                callback(retData.data)
            }
        })
    }



    //推广图片数据
    getPromoteAD(callback) {
        let requestData: IHttpRequestData = {
            baseUrl: "promoters/promotionIndex?",
        }
        this.apiHttpGet(requestData, function (retData) {
            if (callback) {
                callback(retData.data)
            }
        })
    }


    getAward(callback: Function = null) {
        if (this.countData <= 0) {
            ModuleManager.instance.toastKey("promote_getAwardTips")
            return
        }

        if (this.awardData.rewardBalance <= 0) {
            ModuleManager.instance.toastKey("promote_noAwardTips")
            return
        }

        let requestData: IHttpRequestData = {
            baseUrl: "promoters/rewardReceive?",
        }
        this.apiHttpGet(requestData, function (retData) {
            if (callback) {
                callback(retData.data.receiveAmount)
            }
        })
    }

    findPlayer(playerid: String, callback: Function) {
        if (playerid.length <= 0) { return }
        let requestData: IHttpRequestData = {
            baseUrl: "promoters/childInfo?",
            params: {
                childUserId: Number(playerid),
            }
        }
        this.apiHttpGet(requestData, function (retData) {
            cc.log(retData.data)
            if (retData.data == null) {
                ModuleManager.instance.toastKey("promote_findNoplayer")
            }
            else {
                if (callback) {
                    callback(retData.data)
                }
            }
        })
    }

    getAwardCount() {
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "promoters/getGameUserReveiceDayLimit?",
        }
        this.apiHttpGet(requestData, function (retData) {
            self.countData = retData.data.limit - retData.data.recevieNum
        })
    }


    private bindEvent() {
        this.eventBind("event_bind_code", this.showMain)
    }

    // onDestroy(){
    //     this.eventUnBind("event_bind_code", this.showMain)
    // }

}